import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        iconWithCircleFeature: {
          module: () => import('./icon-with-circle.module').then((m) => m.IconWithCircleModule),
        },
      }
    })
  ]
})
export class IconWithCircleFeatureModule {
}
